/* DSL Personalized recs — top types/vendors uit recently-viewed → recommend */
(function(){
  if (!window.DSL_RECENT) return;
  var handles = window.DSL_RECENT.get();
  if (handles.length < 3) return;
  // Fetch laatste 3 producten, extract product_type, fetch related collection
  Promise.all(handles.slice(0, 3).map(function(h){
    return fetch("/products/" + h + ".js").then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
  })).then(function(prods){
    var types = prods.filter(Boolean).map(function(p){ return p.type; }).filter(Boolean);
    if (!types.length) return;
    var top = types.sort(function(a,b){
      return types.filter(function(t){return t===b;}).length - types.filter(function(t){return t===a;}).length;
    })[0];
    var slot = document.querySelector("[data-personal-recs]");
    if (!slot || !top) return;
    fetch("/collections/" + encodeURIComponent(top.toLowerCase()) + "/products.json?limit=4").then(function(r){return r.ok?r.json():null;}).then(function(d){
      if (!d || !d.products) return;
      slot.innerHTML = "<h3>Voor jou — meer " + top + "</h3>" + d.products.map(function(p){
        return "<a href=\"" + p.handle + "\"><img src=\"" + p.featured_image + "&width=200\" width=\"200\" height=\"200\" alt=\"\" loading=\"lazy\"><span>" + p.title + "</span></a>";
      }).join("");
    });
  });
})();